import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { FilledIcon, OutlinedIcon } from '@one/icons';

export interface PredefinedCommentsActivateDeactivateCommandComponentProps {
    onClick: VoidFunction;
    text: string;
    iconName: FilledIcon | OutlinedIcon;
}

export const PredefinedCommentsActivateDeactivateCommandComponent: React.FC<
    PredefinedCommentsActivateDeactivateCommandComponentProps
> = ({ onClick, text, iconName }) => (
    <PocListItem data-testid="predefined-comment-activate-deactivate-command" onClick={onClick}>
        <PocIcon slot="prefix" name={iconName} family="outlined" />
        {text}
    </PocListItem>
);
